import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2RegisterBonusDialogProperties extends BasicDialogProperties {
    public xpbonus: number = 0;
    public timeleft: number = 0;
    public event: number = 0;

    constructor(xpbonus: number, timeleft: number, event: number) {
        super();

        this.timeleft = timeleft;
        this.xpbonus = xpbonus;
        this.event = event;
    }
}
